import React, { useState } from "react";
import "./programs_offered.css";
import { Link } from "react-router-dom";
import programs from "../programs_offered/programsData.js";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const ProgramOffered = () => {
  // Accordion open/close state

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">Programs Offered</h1>
      <hr />
      {programs.map((section, sectionIndex) => (
        <div key={sectionIndex} className="accordion-item">
          {/* Accordion Header */}
          <Accordion
            title={section.title}
            isActive={activeIndex === sectionIndex}
            onClick={() => handleToggle(sectionIndex)}
          />

          {activeIndex === sectionIndex && (
            <div className="prog-off-content">
              {/* Section 1: Image + Info */}
              <div className="prog-off-info-section">
                <div className="prog-off-image">
                  <img src={section.image} alt={section.title} />
                </div>
                <div className="prog-off-content">
                  <p>
                    <b className="innerpage-subheading">Eligibility:</b>{" "}
                    {section.eligibility}
                  </p>
                  <p>
                    <b className="innerpage-subheading">Duration:</b>{" "}
                    {section.duration}
                  </p>
                  <p>
                    <b className="innerpage-subheading">Age (max):</b>{" "}
                    {section.intake}
                  </p>
                  <p>
                    <b className="innerpage-subheading">Intake:</b>{" "}
                    {section.intake}
                  </p>
                </div>
              </div>


              {section.descriptionSections.map((sec, i) => (
                <div key={i}>
                  <h4 className="innerpage-subheading">{sec.heading}</h4>

                  {/* paragraph */}
                  {typeof sec.text === "string" && <p>{sec.text}</p>}

                  {/* list */}
                  {Array.isArray(sec.text) && (
                    <ul className="page-content-lists">
                      {sec.text.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  )}

                  {/* companies */}
                  {sec.companies && (
                    <div style={{ display: "flex", gap: "40px" }}>
                      <ul className="page-content-lists">
                        {sec.companies.col1.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>

                      <ul className="page-content-lists">
                        {sec.companies.col2.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}


              {/*Section 3: Horizontal cards */}
              <div className="prog-off-cards-section">
                <h4 className="innerpage-subheading">
                  Career Path as Marine Engineer:
                </h4>
                <div className="prog-off-cards">
                  {section.careerCards.map((card, i) => (
                    <div className="prog-off-card" key={i}>
                      <h5>{card.title}</h5>
                      <p>{card.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/*Bottom Section */}
              <div className="prog-off-bottom">
                <div className="page-content-note" style={{ margin: "clamp(10px ,2vw,20px) 0" }}>
                  <p> Ready to sail towards a prosperous future?</p>
                  <p> The best college for B. Tech in Marine Engineering!</p>
                </div>
                {/* <button onClick={() => setShowBrochure(true)}>View Brochure</button> */}
                <Link to="/admissions/admission-2026">
                  <button>Apply Now</button>
                </Link>
              </div>
            </div>
          )}
        </div>
      ))}
   
    </div>
  );
};

export default ProgramOffered;
